export class ListMicrosoft365GroupMembers200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "members",
            "baseName": "members",
            "type": "Array<Microsoft365User>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365GroupMembers200Response.attributeTypeMap;
    }
    constructor() {
    }
}
